import React from 'react';
import { Zap, Calendar, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function ProtocolSection() {
  return <section className="py-20 bg-white" data-id="element-162">
      <div className="container mx-auto px-4" data-id="element-163">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-4" data-id="element-165">
            Dos fases para recuperar el control
          </h2>
          <p className="text-lg text-slate-600" data-id="element-166">
            No necesitas improvisar. Hemos diseñado un plan exacto para salir
            del caos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-167">
          {/* Phase 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 relative overflow-hidden" data-id="element-168">
            <div className="absolute top-0 right-0 bg-brand-accent text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-169">
              FASE DE CHOQUE
            </div>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-6 text-brand-accent" data-id="element-170">
              <Zap className="w-6 h-6" data-id="element-171" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-172">
              Protocolo de Emergencia 48h
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-173">
              Para aplicar ESTA MISMA NOCHE. Detén el sangrado emocional
              inmediatamente.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-174">
              <li className="flex items-start text-slate-700" data-id="element-175">
                <span className="w-1.5 h-1.5 bg-brand-accent rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-176" />
                Dispositivos fuera de dormitorios (regla innegociable)
              </li>
              <li className="flex items-start text-slate-700" data-id="element-177">
                <span className="w-1.5 h-1.5 bg-brand-accent rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-178" />
                Aviso 5-2-1 para transiciones sin gritos
              </li>
              <li className="flex items-start text-slate-700" data-id="element-179">
                <span className="w-1.5 h-1.5 bg-brand-accent rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-180" />
                Técnica de respiración 4-4 para activar el nervio vago
              </li>
            </ul>
          </motion.div>

          {/* Phase 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 relative overflow-hidden" data-id="element-181">
            <div className="absolute top-0 right-0 bg-brand-primary text-slate-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-182">
              CONSOLIDACIÓN
            </div>
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-6 text-brand-secondary" data-id="element-183">
              <Calendar className="w-6 h-6" data-id="element-184" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-185">
              Programa de 15 Días
            </h3>
            <p className="text-slate-600 mb-6" data-id="element-186">
              La hoja de ruta día a día para establecer nuevos hábitos que duren
              para siempre.
            </p>
            <ul className="space-y-3 mb-8" data-id="element-187">
              <li className="flex items-start text-slate-700" data-id="element-188">
                <span className="w-1.5 h-1.5 bg-brand-secondary rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-189" />
                Día 1-3: Detox digital y contención emocional
              </li>
              <li className="flex items-start text-slate-700" data-id="element-190">
                <span className="w-1.5 h-1.5 bg-brand-secondary rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-191" />
                Día 4-7: Introducción de juego libre y aburrimiento positivo
              </li>
              <li className="flex items-start text-slate-700" data-id="element-192">
                <span className="w-1.5 h-1.5 bg-brand-secondary rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-193" />
                Día 8-15: Sistema de recompensas y uso consciente
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="mt-12 text-center" data-id="element-194">
          <Button variant="primary" size="lg" className="font-bold" onClick={() => window.open('https://www.digitalgroupfl.com/cart/52737771602031:1', '_blank')} data-id="element-195">
            QUIERO EMPEZAR EL PROTOCOLO HOY
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-196" />
          </Button>
        </div>
      </div>
    </section>;
}